import React from 'react';
import { motion } from 'framer-motion';
import { Users, Copy, DollarSign, TrendingUp } from 'lucide-react';
import { message } from 'antd';

export default function Partners() {
  const referralLink = "https://luckstat.com/?ref=user123";

  const copyLink = () => {
    navigator.clipboard.writeText(referralLink);
    message.success('Ссылка скопирована');
  };

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-white mb-2">Партнерская программа</h1>
        <p className="text-slate-400">Приглашайте друзей и получайте 30% от их платежей пожизненно.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-surface p-6 rounded-xl border border-white/5">
          <div className="text-slate-400 mb-1">Привлечено партнеров</div>
          <div className="text-3xl font-bold text-white">0</div>
        </div>
        <div className="bg-surface p-6 rounded-xl border border-white/5">
          <div className="text-slate-400 mb-1">Активных подписок</div>
          <div className="text-3xl font-bold text-white">0</div>
        </div>
        <div className="bg-surface p-6 rounded-xl border border-white/5">
          <div className="text-slate-400 mb-1">Заработано всего</div>
          <div className="text-3xl font-bold text-emerald-400">0 ₽</div>
        </div>
      </div>

      <div className="bg-gradient-to-r from-primary/20 to-blue-600/20 p-8 rounded-2xl border border-primary/30 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <h3 className="text-xl font-bold text-white mb-1">Ваша реферальная ссылка</h3>
          <p className="text-slate-400 text-sm">Делитесь ею в социальных сетях и чатах</p>
        </div>
        <div className="flex items-center gap-2 bg-black/30 p-2 rounded-lg border border-white/10 w-full md:w-auto">
          <code className="text-emerald-400 px-2">{referralLink}</code>
          <button onClick={copyLink} className="p-2 hover:bg-white/10 rounded-lg transition-colors text-white">
            <Copy size={18} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-surface p-6 rounded-xl border border-white/5">
          <h3 className="font-bold text-white mb-4 flex items-center gap-2">
            <Users size={20} className="text-blue-400" />
            Как это работает?
          </h3>
          <ul className="space-y-3 text-slate-400 text-sm">
            <li className="flex gap-2">
              <span className="text-white font-bold">1.</span>
              Вы отправляете ссылку другу или размещаете её в блоге.
            </li>
            <li className="flex gap-2">
              <span className="text-white font-bold">2.</span>
              Пользователь регистрируется и оплачивает тариф.
            </li>
            <li className="flex gap-2">
              <span className="text-white font-bold">3.</span>
              Вы получаете 30% от каждого его платежа на свой баланс.
            </li>
          </ul>
        </div>

        <div className="bg-surface p-6 rounded-xl border border-white/5">
          <h3 className="font-bold text-white mb-4 flex items-center gap-2">
            <TrendingUp size={20} className="text-emerald-400" />
            Выплаты
          </h3>
          <p className="text-slate-400 text-sm mb-4">
            Минимальная сумма для вывода: 5000 ₽. Выплаты производятся автоматически 1-го и 15-го числа каждого месяца на карту или USDT.
          </p>
          <button className="w-full py-2 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors">
            Настроить реквизиты
          </button>
        </div>
      </div>
    </div>
  );
}
